export function addClick(container) {
    if (communityType === 1) {
        var timelineID = container.closest(".timeline_entry").attr("id");
        $.ajax({
            type: "POST",
            url: "/module/community/ajax.php?action=add_click",
            datatype: "json",
            data: {
                "ajax_call_timeline_id": timelineID
            }
        });
    }
}

